import React from 'react';

import Icon from 'components/Icon/Icon';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {PubFilters, setPubPageFiltersAC} from 'store/pubs/pubSlice';
import {handleQueryDirection} from 'utils/helpers/handleQueryDirection';

interface IProps {
  filters: PubFilters;
}

export const PubPageTableHeader = ({filters}: IProps) => {
  const dispatch = useSetGlobalState();

  const handleSort = (sortParam: 'city' | 'name') => {
    const direction = handleQueryDirection(sortParam, filters);
    dispatch(setPubPageFiltersAC({...filters, column: sortParam, direction}));
  };

  return (
    <div className="pub-pages__header">
      <div className="pub-pages__header-item">
        Pub Name
        <button className="pub-pages-table__sort" onClick={() => handleSort('name')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="pub-pages__header-item">Activity</div>
      <div className="pub-pages__header-item">Generated Post Number</div>
      <div className="pub-pages__header-item">
        City
        <button className="pub-pages-table__sort" onClick={() => handleSort('city')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="pub-pages__header-item"> </div>
    </div>
  );
};
